export default __webpack_public_path__ + "static/media/thumb-need-usdpi.ef95f09a.png";